export const ERROR_UNAUTHORISED = "Unauthorised";

export const INITIAL_VALUES = { email: "", password: "" };
